module.exports = __webpack_public_path__ + "static/media/DistractionTechniques.8a050d4c.png";